import React from 'react';
import {Route, Switch} from "react-router-dom";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../../Boilerplate/BreadcrumbContext";
import MeetingMinuteList from "./MeetingMinuteList";
import MeetingMinuteNew from "./MeetingMinuteNew";
import MeetingMinute from "./MeetingMinute";

const MeetingMinutes = () => (
  <div>
    <Helmet>
      <title>Meeting Minutes</title>
    </Helmet>
    <Switch>
      <Route component={MeetingMinuteUi} />
    </Switch>
  </div>
);

const MeetingMinuteUi = () => (
  <div>
    <Route exact path="/projects/:id/meeting-minutes/" component={MeetingMinuteList}/>
    <Switch>
      <Route path="/projects/:id/meeting-minutes/new" component={MeetingMinuteNew}/>
      <Route path="/projects/:id/meeting-minutes/:meetingMinutesId" component={MeetingMinute}/>
    </Switch>
  </div>
);

export default withBreadcrumb(
  ({ match }) => ({ title: 'Meeting Minutes', path: `/projects/${match.params.id}/meeting-minutes/`}),
  MeetingMinutes
);



// WEBPACK FOOTER //
// ./src/components/Projects/MeetingMinutes/MeetingMinutes.js